import React from "react";
import { MemoizedMarkdown } from "../../../MemoizedMarkdown";
import styles from "./TextMessage.scss";

// Rendered as assistant-ui's Text part component: the text arrives from the
// runtime (bridged from useChat), the markdown renderer stays ours.
export const TextMessage = ({ text }) => {
    return (
        <div className={styles.base} data-part="text">
            <MemoizedMarkdown content={text} />
        </div>
    );
};
